<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="23"
        viewBox="0 0 26 23"
        fill="none"
    >
        <g filter="url(#filter0_d_10282_32403)">
            <path
                d="M9.62427 3H7.07594L6.82926 3.02302C6.13313 3.088 5.53854 3.55232 5.30678 4.21194C5.23979 4.4026 5.20557 4.60323 5.20557 4.80532V7.42593H19.9833V6.24582C19.9833 6.04637 19.9493 5.84839 19.8826 5.66042L19.8778 5.64689C19.6887 5.11416 19.2504 4.70802 18.7048 4.56007C18.5578 4.5202 18.4062 4.5 18.2538 4.5H14.3054C13.7046 4.5 13.1129 4.35388 12.5813 4.07423L11.3484 3.42577C10.8167 3.14612 10.225 3 9.62427 3Z"
                fill="currentColor"
            />
            <path
                opacity="0.5"
                d="M18.1311 5.75879H7.2052C6.55064 5.75879 6.02002 6.28941 6.02002 6.94397V7.92546H19.3163V6.94397C19.3163 6.28941 18.7857 5.75879 18.1311 5.75879Z"
                fill="#8E8E93"
            />
            <g filter="url(#filter1_d_10282_32403)">
                <path
                    d="M20.2552 16.1165L21.2399 9.13507C21.3783 8.15423 20.6168 7.27783 19.6263 7.27783H5.63017C4.62916 7.27783 3.86478 8.17188 4.02035 9.16073L5.1187 16.1422C5.24338 16.9347 5.92628 17.5186 6.72853 17.5186H18.6416C19.4536 17.5186 20.1418 16.9207 20.2552 16.1165Z"
                    fill="currentColor"
                />
            </g>
        </g>
        <defs>
            <filter
                id="filter0_d_10282_32403"
                x="-0.387207"
                y="-0.481445"
                width="26"
                height="23"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_10282_32403"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_10282_32403"
                    result="shape"
                />
            </filter>
            <filter
                id="filter1_d_10282_32403"
                x="3.11111"
                y="6.01857"
                width="19.0341"
                height="12.0185"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="-0.37037" />
                <feGaussianBlur stdDeviation="0.444444" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.235294 0 0 0 0 0.235294 0 0 0 0 0.235294 0 0 0 0.12 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_10282_32403"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_10282_32403"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
</template>
